<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem>
          <el-select v-model="opIds" multiple collapse-tags filterable clearable placeholder="全部人员">
            <el-option v-for="item in agentData" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem>
          <el-select v-model="mediaIds" multiple collapse-tags filterable clearable placeholder="全部媒体">
            <el-option v-for="item in mediaData" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem>
          <el-select v-model="projectGroupIds" multiple collapse-tags filterable clearable placeholder="全部项目组">
            <el-option v-for="item in projectGroupData" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem>
          <el-select v-model="middleGameIds" multiple collapse-tags filterable clearable placeholder="全部中间件游戏">
            <el-option v-for="item in middleGameData" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem>
          <el-select v-model="gameIds" multiple collapse-tags filterable clearable placeholder="全部游戏">
            <el-option v-for="item in gameData" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem>
          <el-select v-model="platforms" multiple collapse-tags filterable clearable placeholder="全部平台">
            <el-option v-for="item in platformData" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem>
          <ElDatePicker
            v-model="reportMonth"
            :picker-options="datetimeOption"
            :clearable="false"
            value-format="yyyy-MM"
            type="month"
            placeholder="请选择月份"
            @change="handleMonth"
          />
        </ElFormItem>

        <ElFormItem label-width="0" class="bg-transparent">
          <el-button type="primary" @click="sendEvent">查询</el-button>
          <el-button @click="$emit('on-down')">数据导出</el-button>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
const platformData = [
  { id: 1, name: '安卓' },
  { id: 2, name: 'IOS' }
]
export default {
  name: 'robotFilter',
  props: {
    gameData: {
      type: Array
    },
    agentData: {
      type: Array
    },
    projectGroupData: {
      type: Array
    },
    mediaData: {
      type: Array
    },
    middleGameData: {
      type: Array
    }
  },
  methods: {
    sendEvent() {
      const params = {
        opIdsStr: this.opIds ? this.opIds.join(',') : '',
        mediaIdStr: this.mediaIds ? this.mediaIds.join(',') : '',
        projectGroupOpIds: this.projectGroupIds ? this.projectGroupIds.join(',') : '',
        midGameIdsStr: this.middleGameIds ? this.middleGameIds.join(',') : '',
        gameIdStr: this.gameIds ? this.gameIds.join(',') : '',
        platformStr: this.platforms ? this.platforms.join(',') : '',
        reportMonth: this.reportMonth
      }
      this.$emit('on-change', params)
    },
    handleMonth() {
      this.sendEvent()
    }
  },
  data() {
    return {
      gameIds: [],
      opIds: [],
      projectGroupIds: [],
      mediaIds: [],
      middleGameIds: [],
      platforms: [],
      platformData,
      reportMonth: moment().format('YYYY-MM'),
      datetimeOption: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        }
      }
    }
  },
  created() {
    this.sendEvent()
  }
}
</script>
